import { render, staticRenderFns } from "./TabErrors.vue?vue&type=template&id=0c6d544a&scoped=true&"
import script from "./TabErrors.vue?vue&type=script&lang=js&"
export * from "./TabErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6d544a",
  null
  
)

export default component.exports